
/**
 * Responsive pricing table (block 3)
 */

+function($){

    page.initPricing = function() {

        $(document).on('click', '.compare-table ul li a', function(){
            let pos = $(this).parent().index() + 2; //Тъй като .index() започва да брои от 0 и в td-то първото е заглавието, затова се слага +2
            $(this).closest('.compare-table').find('tr').find( 'td:not(:first)').hide(); // Скрива всички td елементи, без първия елемент, тъй като там е заглавието на feature-a
            $(this).closest('.compare-table').find('td:nth-child(' + pos + ')').css( 'display', 'table-cell' );  //Слага със table-cell, защото по подразбиране .show() слага display:block; Това го прави с nth-child, за да може да хване от всяко tr елементите
        });
    }

}(jQuery);
